import { CartContainerItemFragment as CartContainerItemFragmentType } from '@/features/graphql/generated/graphql'
import { CartContainerItemFragment } from '@/features/pos/components/Cart/fragments/cartContainerItem'
import { calculateTotalPriceFromUnitPrice } from '@/utils/calculateTotalPriceFromUnitPrice'
import type { ApolloClient } from '@apollo/client'

export const updateCartContainerItemQuantityCache = (
    client: ApolloClient<object>,
    id: string,
    quantityChange: number
): void => {
    const cacheId = client.cache.identify({ __typename: 'CartContainerItem', uuid: id })
    const item = client.cache.readFragment({
        id: cacheId,
        fragment: CartContainerItemFragment,
        fragmentName: 'CartContainerItem',
    })

    if (!item) return

    const quantity = item.quantity + quantityChange

    client.cache.writeFragment({
        id: cacheId,
        fragment: CartContainerItemFragment,
        fragmentName: 'CartContainerItem',
        data: {
            ...item,
            quantity,
            totalPrice: calculateTotalPriceFromUnitPrice(item.container.price, quantity),
        } satisfies CartContainerItemFragmentType,
    })
}
